import type { IBreadcrumb } from '@/components/ui/Breadcrumbs/Breadcrumb/interfaces'
import { agriculturalProductsBreadcrumb } from '@/components/ui/Breadcrumbs/constants'
import { EAgriculturalProductsRoute } from '@/types'
import type { IAgriculturalProductTreeCategory } from '@/types/Catalog'
import { createRouterLink } from '@/utils/url'

export const getCategoryNameInGenitiveCase = (name: string): string =>
  name
    .replace(/(и)(\s+|$)/g, 'ей$2')
    .replace(/(ы)$/g, 'ов')
    .replace('ка', 'ки')
    .replace('ия', 'ий')
    .replace('ные', 'ных')
    .replace('ена', 'ян')
    .replace(/(а)(\s+|$)/g, '$2')

export const getCategoryUrl = (id: number): string => createRouterLink(EAgriculturalProductsRoute.category, { categoryId: id })

const getCategoryBreadcrumb = (category: IAgriculturalProductTreeCategory, isLastCategoryAvailable?: boolean): IBreadcrumb => {
  const { name: caption, id, active } = category
  const breadcrumb: IBreadcrumb = { caption }

  if (!active || isLastCategoryAvailable) breadcrumb.link = getCategoryUrl(id)

  return breadcrumb
}

export interface IGetAgriculturalProductsCatalogBreadcrumbs {
  breadcrumbs?: IBreadcrumb[]
  category?: IAgriculturalProductTreeCategory
  isLastCategoryAvailable?: boolean
}

export const getAgriculturalProductsCatalogBreadcrumbs = (options: IGetAgriculturalProductsCatalogBreadcrumbs): IBreadcrumb[] => {
  const { breadcrumbs = [agriculturalProductsBreadcrumb], category, isLastCategoryAvailable } = options

  if (!category) return breadcrumbs

  breadcrumbs.push(getCategoryBreadcrumb(category, isLastCategoryAvailable))

  if (category.active) return breadcrumbs

  for (const childCategory of category.children ?? []) {
    getAgriculturalProductsCatalogBreadcrumbs({ breadcrumbs, category: childCategory, isLastCategoryAvailable })

    if (childCategory.active) break
  }

  return breadcrumbs
}
